import type { ProductImageType } from 'product/types'
import type { ProductImage, ProductLook } from 'product/types/Product'

export const sortImagesByOrder = (
	images: ProductLook['images'],
	order: ProductImageType[]
): ProductImage[] => {
	const sortedImages = order
		.map((key) => images[key])
		.filter((image): image is ProductImage => !!image)

	if (sortedImages.length > 0) {
		return sortedImages
	}

	const [fallbackImage] = Object.values(images)
	return [fallbackImage]
}
